/**
 * The output aspect ratios a job can ask for, in the one spelling the pipeline uses.
 *
 * vtkpy owns this vocabulary end to end: what the form sends here is what the encoding profile
 * checks against and what ffmpeg is handed in `setdar=`. Nothing in between translates, so these
 * strings have to match `vtkpy.helper.aspectratio` exactly -- the workflow side mirrors the same
 * list in `content-workflow-cdk/utils_lambdas/utils_util_layer/aspect_ratio.py`.
 */

/** Deliver the source's own shape. Also what an absent aspect_ratio means. */
export const ASPECT_RATIO_PASSTHROUGH = 'passthrough';

/** The ratios a profile can deliver. Portrait ones are the Astrova reel panels. */
export const ASPECT_RATIOS = ['16/9', '4/3', '9/16', '3/4'] as const;

/** Suffix that fits the picture inside the ratio with black bars instead of stretching it. */
export const ASPECT_RATIO_FRAMED_SUFFIX = '_framed';

/**
 * How a PO item's stored aspect_ratio reads on screen.
 *
 * Items encoded before the canonical spelling landed hold `16x9`, `4x3` or an empty string; they
 * are shown as what they meant rather than as a value the platform would accept today.
 */
export function aspectRatioLabel(value: string | null | undefined): string {
  switch (value) {
    case null:
    case undefined:
    case '':
    case ASPECT_RATIO_PASSTHROUGH:
      return 'pass through';
    case '16x9':
      return '16/9 (forced)';
    case '4x3':
      return '4/3 (forced)';
    default:
      return value.endsWith(ASPECT_RATIO_FRAMED_SUFFIX)
        ? `${value.slice(0, -ASPECT_RATIO_FRAMED_SUFFIX.length)} (fitted, black bars)`
        : `${value} (forced)`;
  }
}
